/* eslint-disable no-param-reassign */
import axios from 'axios'
const headers = {
  'Accept-Language': 'en',
  'language-code': 'en',
  'Content-Type': 'application/json',
}

export const setAuthToken = () => {
  const token = sessionStorage.getItem('syngentaBearerToken')
  const countryCode = sessionStorage.getItem('syngentaCountryCode')
  const allowAccessCode = countryCode === 'TH' ? 'TH-POC' : null
  return { ...headers, Authorization: token, 'allow-access': allowAccessCode }
}

export const setCountryCode = () => {
  const superAdminCountryCode = sessionStorage.getItem('superAdminCountryCode')
  return { ...headers, 'country-code': superAdminCountryCode }
}

const makeRequest = (url, method = 'GET', body = {}, options, axiosOptions = null) => {
  let allOptions = { headers: { ...setAuthToken(), ...setCountryCode(), ...options } }

  if (axiosOptions) {
    allOptions = { ...allOptions, ...axiosOptions }
  }

  switch (method) {
    case 'GET':
      return axios.get(url, allOptions)

    case 'POST':
      return axios.post(url, body, allOptions)

    case 'PUT':
      return axios.put(url, body, allOptions)

    case 'PATCH':
      return axios.patch(url, body, allOptions)

    case 'DELETE':
      return axios.delete(url, allOptions)

    default:
      return axios.get(url, {}, allOptions)
  }
}

export default makeRequest
